/*
 * CMP-017 Virtual try-on canvas — Phase A1. No dependencies, no renderer: it shows what the host gives it.
 *   NcTryon.setStatus(root, 'idle' | 'loading' | 'rendered' | 'error', message?)  updates the visible state and the
 *   polite live region; loading and error keep the stage size (no layout shift). The image always shows at its natural fit.
 * Toolbar (vertical): roving tabindex, ArrowUp/ArrowDown (wrap), Home/End; Enter/Space activate -> `nc-tryon:tool` {id}.
 * Error shows "Reintentar" -> `nc-tryon:retry`. Garment capacity, slots and the rendering pipeline are out of scope (UNKNOWN).
 * renderToCanvas(status) maps a gateway render status (getLookRender, PROPOSED) to the canvas state: queued and processing
 * show loading, ready shows rendered, failed and blocked show error (their copy and the consent step need design: not in Figma).
 */
(function () {
  // next toolbar index for a key (wraps); null when not handled
  function getToolIndex(key, current, count) {
    var next = { ArrowUp: current - 1, ArrowLeft: current - 1, ArrowDown: current + 1, ArrowRight: current + 1, Home: 0, End: count - 1 }[key];
    if (next === undefined || count < 1) return null;
    return (next + count) % count;
  }

  // gateway render status -> canvas state; unknown statuses are errors, never a silent "rendered"
  function renderToCanvas(status) {
    return { queued: 'loading', processing: 'loading', ready: 'rendered' }[status] || 'error';
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { getToolIndex: getToolIndex, renderToCanvas: renderToCanvas };
  if (typeof customElements === 'undefined' || customElements.get('nc-tryon')) return;

  class NcTryonElement extends HTMLElement {
    connectedCallback() {
      // bound once: a host may move the element (the fitting room reorders its stage on the two-column desktop)
      if (this.bound) return;
      this.bound = true;
      this.figure = this.querySelector('.nc-tryon__figure');
      this.liveRegion = this.querySelector('[data-nc-tryon-status]');
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.sync();
    }

    get tools() {
      return Array.prototype.slice.call(this.querySelectorAll('.nc-tryon__tools .nc-icon-button'));
    }

    get status() { return this.getAttribute('data-status'); }

    setStatus(status, message) {
      this.setAttribute('data-status', status);
      var img = this.querySelector('.nc-tryon__image');
      if (img) img.hidden = status !== 'rendered';
      this.sync();
      if (this.liveRegion) {
        var block = this.querySelector('.nc-tryon__message--' + status);
        this.liveRegion.textContent = message || (block ? block.textContent.replace(/\s+/g, ' ').trim() : '');
      }
    }

    sync() {
      this.figure.setAttribute('aria-busy', this.status === 'loading' ? 'true' : 'false');
    }

    onClick(event) {
      var tool = event.target.closest('.nc-tryon__tools .nc-icon-button');
      if (tool) {
        this.dispatchEvent(new CustomEvent('nc-tryon:tool', { bubbles: true, detail: { id: tool.getAttribute('data-id') } }));
        return;
      }
      if (event.target.closest('.nc-tryon__retry')) this.dispatchEvent(new CustomEvent('nc-tryon:retry', { bubbles: true }));
    }

    onKeydown(event) {
      var list = this.tools;
      var i = list.indexOf(event.target);
      if (i < 0) return;
      var next = getToolIndex(event.key, i, list.length);
      if (next === null) return;
      event.preventDefault();
      list.forEach(function (t, n) { t.setAttribute('tabindex', n === next ? '0' : '-1'); });
      list[next].focus();
    }
  }

  customElements.define('nc-tryon', NcTryonElement);

  window.NcTryon = {
    renderToCanvas: renderToCanvas,
    setStatus: function (root, status, message) { root.setStatus(status, message); }
  };
})();
